import { ShiftManagementDefaultShiftsDocument } from 'generated/resources/graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useDefaultShifts } from 'modules/shift_management/hooks/useDefaultShifts'
import DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

const useFetchDefaultShifts = () => {
  const [, dispatchDefaultShifts] = useDefaultShifts()
  const { loading, data } = useQuery(ShiftManagementDefaultShiftsDocument, {})

  const defaultShifts: DefaultShifts = useUnsafeMemo(
    () => DefaultShifts.buildFromGraphQL(data?.shiftManagement?.defaultShifts || []),
    [data?.shiftManagement.defaultShifts]
  )

  useUnsafeEffect(() => {
    if (!loading) dispatchDefaultShifts({ type: 'BOOTSTRAP', defaultShifts })
  }, [dispatchDefaultShifts, loading, defaultShifts])

  return { defaultShifts, loading }
}

export default useFetchDefaultShifts
